<!--
 * @Descripttion: 
 * @version: 
 * @Author: wutao
 * @LastEditors: wutao
 * @LastEditTime: 2025-07-19 23:09:06
-->
<template>
  <div id="app">
    <router-view /> <!-- 显示对应页面 -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
